import {
  CheckMarkLaporankerja,
  DisabledCheckLaporankerja,
  ImageDirian,
  XMarkLaporankerja,
} from '../../../assets';
import {Language} from '../../../context/LanguageContext';
export default function LaporanKerjaLadangCard({
  title,
  date,
  onClick,
  taskStatus,
}) {
  const {newObj, language} = Language();
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };
  const handleMarkStatus = (status) => {
    if (status === 0 || status === 1) {
      return (
        <img src={DisabledCheckLaporankerja} className='tarikh_icon' alt='' />
      );
    } else if (status === 2) {
      return <img src={CheckMarkLaporankerja} className='tarikh_icon' alt='' />;
    } else {
      return <img src={XMarkLaporankerja} className='tarikh_icon' alt='' />;
    }
  };
  console.log('taskStatus', taskStatus);
  return (
    <div className='lk_card' onClick={onClick}>
      <img src={ImageDirian} className='static_image' alt='' />
      <div className='lk_content'>
        <p className='lk_title'>{title}</p>
        <div className='lk_bottom_content'>
          <div className='lk_date'>
            {handleMarkStatus(taskStatus)}
            {newObj.DateWord[language]}: {formatDate(date)}
          </div>
          <div>
            {/* <img src={CheckMarkLaporankerja} className='tarikh_icon' alt='' /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
